import operator from 'operator'
import delegate from 'delegate'
import bus from './bus.js'
import { toUri } from './helpers.js'

let previousLocation = window.location.pathname
window.GWLA_HISTORY = []
window.GWLA_SCROLL = {}
let loadingTimeout = null
let pageCount = 0

const app = window.GWLA_APP = operator('#content', [
  {
    path: `${window.SITE_BASE}/index/:gallery`,
    handler (state) {
      const currentUri = toUri(state.location)
      bus.emit('map:set-location', currentUri)
    }
  }
])

// Set previous location on link click
// -> Using delegate instead of app.on('before'),
// since `before` does not run on same route
delegate(document.body, 'a[href]', 'click', e => {
  previousLocation = window.location.pathname
  window.GWLA_HISTORY.push(window.location.pathname)
}, true)

// Close existing popup on `before` navigate
app.on('before', state => {
  // Keep track of previous scroll positions on different pages
  window.GWLA_SCROLL[window.location.pathname] = window.scrollY
  bus.emit('map:close-permanent-popup')
})

app.on('navigate', state => {
  // Don't do anything when navigating to same route
  if (previousLocation === state.location) return

  // Add loading timeout after 250ms
  loadingTimeout = setTimeout(() => {
    document.documentElement.classList.add('loading')  
  }, 250)

  pageCount++
})

app.on('after', ({ previousDocument, location }) => {
  // Clear loading timeout
  clearTimeout(loadingTimeout)
  document.documentElement.classList.remove('loading')

  // Update title
  document.title = previousDocument.title

  // Update route
  window.history.pushState({}, '', location)

  // Update opengraph
  let opengraphTags = [...previousDocument.querySelectorAll('[property^="og:"]')]
  opengraphTags.forEach(tag => {
    let existingOpengraphTag = document.querySelector(`[property="${tag.getAttribute('property')}"`)
    if (existingOpengraphTag) existingOpengraphTag.content = tag.content
  })

  // Update classes
  updateClasses(previousDocument)

  // Reset scroll position
  if (window.GWLA_SCROLL[location]) {
    window.scrollTo(0, window.GWLA_SCROLL[location])
  } else {
    window.scrollTo(0, 0)
  }
})

/**
 * Add a `data-operator-classes` attribute to all elements
 * outside the operator viewport that should have their 
 * classList updated on navigate.
 */ 
function updateClasses (previousDocument) {
  const oldElements = [...previousDocument.querySelectorAll('[data-operator-classes]')]
  const newElements = [...document.querySelectorAll('[data-operator-classes]')]
  newElements.forEach((newElement, i) => {
    let oldElement = oldElements[i]
    let oldClasses = [...oldElement.classList]
    let newClasses = [...newElement.classList]
    let classesToRemove = newClasses.filter(x => !oldClasses.includes(x))
    let classesToAdd = oldClasses.filter(x => !newClasses.includes(x))
    newElement.classList.remove(...classesToRemove)
    newElement.classList.add(...classesToAdd)
  })
}

delegate(document.body, '[data-operator-back]', 'click', e => {
  if (window.GWLA_HISTORY.length >= 2) {
    e.preventDefault()
    e.stopPropagation()
    
    // 1. remove current item from history stack
    const currentItem = window.GWLA_HISTORY.pop()
    
    // 2. get last item from history stack (and remove)
    let lastItem = window.GWLA_HISTORY.pop()
    
    // 3. if the current page was a gallery view,
    // iterate through history stack for the first
    // non-gallery item
    const GalleryViewRegex = new RegExp('^index\/.+')
    if (GalleryViewRegex.test(toUri(currentItem))) {
      while (lastItem && GalleryViewRegex.test(toUri(lastItem))) {
        lastItem = window.GWLA_HISTORY.pop()
      }
    }
    
    // 4. navigate back
    app.go(lastItem || '/')
  }
}, true)